/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendClaimEmailRequestAttachmentsInner
 */
export interface SendClaimEmailRequestAttachmentsInner {
    /**
     * Filename without ASCII or Unicode control characters
     * @type {string}
     * @memberof SendClaimEmailRequestAttachmentsInner
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof SendClaimEmailRequestAttachmentsInner
     */
    mimeType: string;
    /**
     * Non-empty Base64-encoded attachment content
     * @type {string}
     * @memberof SendClaimEmailRequestAttachmentsInner
     */
    contentBase64: string;
}

/**
 * Check if a given object implements the SendClaimEmailRequestAttachmentsInner interface.
 */
export function instanceOfSendClaimEmailRequestAttachmentsInner(value: object): value is SendClaimEmailRequestAttachmentsInner {
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    if (!('contentBase64' in value) || value['contentBase64'] === undefined) return false;
    return true;
}

export function SendClaimEmailRequestAttachmentsInnerFromJSON(json: any): SendClaimEmailRequestAttachmentsInner {
    return SendClaimEmailRequestAttachmentsInnerFromJSONTyped(json, false);
}

export function SendClaimEmailRequestAttachmentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendClaimEmailRequestAttachmentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'],
        'mimeType': json['mimeType'],
        'contentBase64': json['contentBase64'],
    };
}

export function SendClaimEmailRequestAttachmentsInnerToJSON(json: any): SendClaimEmailRequestAttachmentsInner {
    return SendClaimEmailRequestAttachmentsInnerToJSONTyped(json, false);
}

export function SendClaimEmailRequestAttachmentsInnerToJSONTyped(value?: SendClaimEmailRequestAttachmentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'contentBase64': value['contentBase64'],
    };
}

